import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
const staticElementCreator = (htmlElement, tagProps) => {
    const el = createElement(htmlElement, tagProps);
    return renderToStaticMarkup(el);
};
export default staticElementCreator;
//# sourceMappingURL=staticElementCreator.js.map